module.exports = __webpack_public_path__ + "img/t4t.ff4a08e6.png";